/**
 * Collection Tabs — Products / Lookbook / Campaign, or Products / On body
 *
 * Reads ?view= from the URL on load, sets the active tab/panel, and intercepts
 * tab clicks to update the URL via History API (preserves Shopify filter params).
 * Also reacts to popstate so back/forward buttons work.
 *
 * "onbody" is not a panel of its own: it keeps the products panel open and sets
 * data-active-view="onbody" on the page, which the collection section styles.
 */

(function () {
  const VALID_VIEWS = ["products", "lookbook", "campaign", "onbody"];
  const root = document.querySelector(".listing-page");
  if (!root) return;

  const tabsNav = root.querySelector(".collection-tabs-nav");
  if (!tabsNav) return; // tabs not enabled on this collection

  const tabs = Array.from(tabsNav.querySelectorAll(".collection-tab"));
  const panels = Array.from(root.querySelectorAll(".collection-tab-panel"));
  if (!tabs.length || !panels.length) return;

  function getInitialView() {
    const params = new URLSearchParams(window.location.search);
    const requested = params.get("view");
    if (requested && VALID_VIEWS.includes(requested)) {
      // ensure the requested view actually has a corresponding panel rendered
      if (panels.some((p) => p.dataset.view === requested)) return requested;
      if (requested === "onbody" && tabs.some((t) => t.dataset.view === "onbody" && !t.hidden)) return requested;
    }
    return "products";
  }

  function setView(view, { updateUrl = true } = {}) {
    if (!VALID_VIEWS.includes(view)) view = "products";

    // Update tab buttons
    tabs.forEach((t) => {
      t.setAttribute("aria-current", t.dataset.view === view ? "true" : "false");
    });

    // Update panel visibility
    const panelView = view === "onbody" ? "products" : view;
    panels.forEach((p) => {
      p.setAttribute("data-active", p.dataset.view === panelView ? "true" : "false");
    });

    // Reflect on the root for view-specific styling
    root.setAttribute("data-active-view", view);

    // Update URL
    if (updateUrl) {
      const params = new URLSearchParams(window.location.search);
      if (view === "products") {
        params.delete("view");
      } else {
        params.set("view", view);
      }
      // When switching TO Campaign, drop any active filters (filters don't apply there)
      if (view === "campaign") {
        Array.from(params.keys()).forEach((k) => {
          if (k.startsWith("filter.")) params.delete(k);
        });
      }
      const qs = params.toString();
      const newUrl = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
      window.history.replaceState({ view }, "", newUrl);
    }
  }

  // Click handlers
  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      setView(tab.dataset.view);
      if (window.gtag) {
        window.gtag("event", "collection_tab_click", { view: tab.dataset.view });
      }
      // Smooth scroll to the top of the panel area
      const navOffset = tabsNav.getBoundingClientRect().bottom;
      if (navOffset < 0) {
        tabsNav.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  // Popstate: handle browser back/forward
  window.addEventListener("popstate", () => {
    setView(getInitialView(), { updateUrl: false });
  });

  // Initial setup
  setView(getInitialView(), { updateUrl: false });
})();
